import { useSelector } from "react-redux";
import {
  selectIsSubscriptionRestricted,
  selectSubscriptionAccess,
  selectShowExpiryNotice,
} from "../app/auth/authSlice";

/**
 * BackOffice subscription phase (active / grace / restricted).
 */
export default function useSubscriptionRestricted() {
  const subscriptionAccess = useSelector(selectSubscriptionAccess);
  const isRestricted = useSelector(selectIsSubscriptionRestricted);
  const showExpiryNotice = useSelector(selectShowExpiryNotice);

  return {
    subscriptionAccess,
    isRestricted,
    isInGracePeriod: subscriptionAccess.isInGracePeriod,
    showExpiryNotice,
    canMutate: !isRestricted,
  };
}
